/* eslint-disable no-unused-vars */
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  getIdTokenResult,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from "firebase/auth";
import { firebaseConfig } from "../FirebaseConfig";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import axios from "axios";

const auth = getAuth();

export const login = ({ email, password }) => {
  try {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        sessionStorage.setItem(
          "expiresIn",
          userCredential._tokenResponse.expiresIn
        );
        sessionStorage.setItem(
          "idToken",
          userCredential._tokenResponse.idToken
        );
        window.location.replace(`${window.location.origin}`);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        toast.error(errorMessage.split(" ")[2]);
      });
  } catch (error) {
    console.log("error12", error);
  }
};
export const resetPassword = async (email) => {
  let data = {
    email: email,
  };

  return await axios
    .post(`${process.env.REACT_APP_URL}/users/forget-password`, data)
    .then((response) => {
      toast.success("Please check Email for reset password link");
      return true;
    })
    .catch((error) => {
      const errorMessage = error.response.data.message;
      console.error(errorMessage);
      toast.error(errorMessage);
    });
};

export const refreshToken = async () => {
  return await getIdTokenResult(auth, true)
    .then(function (idToken) {
      console.log(idToken);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const checkPasswordResetCode = async (code, email) => {
  return await verifyPasswordResetCode(auth, code)
    .then((email) => {
      return email;
    })
    .catch((err) => {
      if (err.code === "auth/expired-action-code") {
        console.log("resend code");
        resetPassword(email);
      }
      toast.error(err.message.substring(22, 41));
      return err;
    });
};

export const setNewPassword = async (code, email, password) => {
  let data = {
    token: code,
    email: email,
    password: password,
  };

  return await axios
    .post(`${process.env.REACT_APP_URL}/users/reset-password`, data)
    .then((response) => {
      toast.success("Password Reset Successfully");
      return true;
    })
    .catch((error) => {
      const errorMessage = error.response.data.message;
      console.error(errorMessage);
      toast.error(errorMessage);
    });
};
